package pl.mothdigital.neuronowi.pages.therapies.terapiaLogopedyczna

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapyLogopedicPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Terapia logopedyczna",
            icon = { FaBook() },
            description = "Kompleksowa diagnoza i terapia zaburzeń mowy, komunikacji oraz funkcji prymarnych u dzieci i dorosłych.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest terapia logopedyczna?",
                    content = """
                        Terapia logopedyczna to kompleksowe podejście do diagnozy i leczenia zaburzeń komunikacji,
                        mowy, języka, głosu oraz funkcji prymarnych (oddychania, połykania, żucia).
                        W Centrum Terapii NeuroNowi oferujemy profesjonalną pomoc zarówno dzieciom, jak i dorosłym,
                        którzy doświadczają trudności w obszarze komunikacji werbalnej.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia logopedyczna?",
                    content = """
                        Terapia logopedyczna jest dedykowana osobom w każdym wieku, które zmagają się z:
                        • Opóźnionym rozwojem mowy u dzieci
                        • Wadami wymowy (dyslalią)
                        • Jąkaniem i innymi zaburzeniami płynności mowy
                        • Zaburzeniami głosu
                        • Afazją (utratą zdolności mowy po udarze)
                        • Trudnościami w czytaniu i pisaniu
                        • Zaburzeniami funkcji prymarnych
                        • Zaburzeniami komunikacji u dzieci z autyzmem
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii logopedycznej w naszym centrum obejmuje:

                        1. Diagnozę - szczegółową ocenę umiejętności komunikacyjnych, badanie narządów artykulacyjnych oraz analizę funkcji prymarnych.

                        2. Plan terapii - opracowanie indywidualnego programu terapeutycznego uwzględniającego potrzeby i możliwości pacjenta.

                        3. Regularne sesje terapeutyczne - ćwiczenia artykulacyjne, oddechowe, fonacyjne oraz usprawniające motorykę narządów mowy.

                        4. Współpracę z rodzicami/opiekunami - przekazanie wskazówek do pracy w domu, co znacząco zwiększa efektywność terapii.

                        5. Ewaluację postępów - regularną ocenę efektów terapii i modyfikację planu w zależności od postępów.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii logopedycznej stosujemy różnorodne techniki i podejścia dostosowane do indywidualnych potrzeb pacjenta:

                        • Masaż logopedyczny
                        • Ćwiczenia artykulacyjne, oddechowe i fonacyjne
                        • Terapię miofunkcjonalną
                        • Elementy metody Padovan
                        • Stymulację funkcji językowych
                        • Terapię z wykorzystaniem aplikacji i narzędzi cyfrowych
                        • Ćwiczenia słuchu fonematycznego
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię logopedyczną w Centrum Terapii NeuroNowi prowadzą certyfikowani logopedzi i neurologopedzi
                        z wieloletnim doświadczeniem klinicznym. Nasi specjaliści regularnie podnoszą swoje kwalifikacje,
                        aby zapewnić pacjentom dostęp do najnowszych i najbardziej skutecznych metod terapeutycznych.
                    """.trimIndent()
                )
            )
        )
    )
}
